export enum SnackbarType {
    SUCCESS = 'success',
    ERROR = 'error',
    WARNING = 'warning',
    INFO = 'info',
}

export interface SnackbarAction {
    title: string
    onClick: () => void
}

export interface SnackbarMessage {
    id: string
    type: SnackbarType
    message: string
    duration: number
    action?: SnackbarAction
    secondaryAction?: SnackbarAction
}

let snackbarInstance: {
    showSnackbar: (type: SnackbarType, message: string, duration?: number, action?: SnackbarAction, secondaryAction?: SnackbarAction) => string
    removeSnackbar: (id: string) => void
} | null = null

export const setSnackbarInstance = (instance: typeof snackbarInstance) => {
    snackbarInstance = instance
}

export const showSnackbar = (
    type: SnackbarType,
    message: string,
    duration?: number,
    action?: SnackbarAction,
    secondaryAction?: SnackbarAction
): string | undefined => {
    // Never render an empty toast. Some flows (e.g. the email provider picker reporting a
    // cancel via onError('')) pass a blank message purely to reset caller state — that must
    // not surface as a contentless notification.
    if (!message || !message.trim()) {
        return undefined
    }
    if (!snackbarInstance) {
        console.warn('Snackbar instance not initialized. Make sure SnackbarProvider is mounted.')
        return undefined
    }
    return snackbarInstance.showSnackbar(type, message, duration, action, secondaryAction)
}

export const dismissSnackbar = (id: string) => {
    snackbarInstance?.removeSnackbar(id)
}

export const showSuccess = (message: string, duration?: number, action?: SnackbarAction): string | undefined => {
    return showSnackbar(SnackbarType.SUCCESS, message, duration, action)
}

export const showError = (message: string, duration?: number, action?: SnackbarAction): string | undefined => {
    return showSnackbar(SnackbarType.ERROR, message, duration, action)
}

export const showWarning = (message: string, duration?: number, action?: SnackbarAction): string | undefined => {
    return showSnackbar(SnackbarType.WARNING, message, duration, action)
}

export const showInfo = (message: string, duration?: number, action?: SnackbarAction): string | undefined => {
    return showSnackbar(SnackbarType.INFO, message, duration, action)
}
